import classNames from "classnames";
import {forwardRef, InputHTMLAttributes} from "react";

import styles from "./SwitchInput.module.scss";

export interface SwitchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  className?: string;
}

const SwitchInput = forwardRef<HTMLInputElement, SwitchInputProps>(({id, className, ...rest}, ref) => {
  return (
    <input
      type="checkbox"
      role="switch"
      className={classNames("form-check-input", styles.switchInput, className)}
      id={id}
      ref={ref}
      {...rest}
    />
  );
});

SwitchInput.displayName = "SwitchInput";
export {SwitchInput};
